import React from 'react';
import { useTranslation } from 'react-i18next';

import { DropdownRendererParameters } from '../../../Autocomplete/components/Autocomplete';
import { default as BaseButton } from '../../../BaseComponents/Button';

import { useTheme } from '../../../theme';

import { Location } from '../../types';
import { Item } from '../../../Autocomplete/types';

interface OwnProps {
	options: Item<Location>[];
	showButton?: boolean;
	onButtonClick?: () => void;
}

type Props = Pick<DropdownRendererParameters<Location>, 'renderGroup' | 'renderOption'> & OwnProps;

const LocationOptionsList: React.FC<Props> = ({
	options,

	renderGroup,
	renderOption,

	showButton,
	onButtonClick
}) => {
	const { LocationOptionsList: css } = useTheme('LocationAutocomplete');
	const { t } = useTranslation('LocationAutocomplete');

	return (
		<div className={css.locationOptionsList__wrapper}>
			<div className={css.locationOptionsList__list}>
				{options.map((item, index) => ('value' in item ? renderOption(item, index) : renderGroup(item, index)))}
			</div>

			{showButton && !!onButtonClick && (
				<div className={css.locationOptionsList__buttonWrapper}>
					<BaseButton
						variant="smallThird"
						className={css.locationOptionsList__button}
						onMouseDown={onButtonClick}
					>
						{t('show all directions')}
					</BaseButton>
				</div>
			)}
		</div>
	);
};

export default LocationOptionsList;
